import React from 'react';
import classNames from 'classnames';

import * as Types from 'types';

import { PlayableArtworkThumbnail } from 'components/artworks/PlayableArtworkThumbnail';
import { ArtworkThumbnail } from 'components/artworks/ArtworkThumbnail';
import { ArtworkTitle } from 'components/artworks/ArtworkTitle';

type Props = {
  playlistArtwork: Types.PlaylistArtwork;
  onPlayButtonClick?: (playlistArtwork: Types.PlaylistArtwork) => void;
} & Types.Styleable;

export const PlaylistArtworkPill: React.FC<Props> = (props) => {
  const { playlistArtwork, onPlayButtonClick, style } = props;
  const { artwork } = playlistArtwork;
  const className = classNames('artwork-pill', props.className);

  const renderThumbnail = () =>
    onPlayButtonClick ?
      <PlayableArtworkThumbnail
        artwork={artwork}
        onPlay={() => onPlayButtonClick(playlistArtwork)}
      />
      : <ArtworkThumbnail artwork={artwork} />

  return (
    <div style={style} className={className}>
      <div className='artwork-pill__thumbnail'>{renderThumbnail()}</div>
      <div className='artwork-pill__content'>
        <ArtworkTitle
          artwork={artwork}
          className='artwork-header--xsm d-flex align-items-center'
          maxlength={48}
          showWatermarkedIndicator
        />
      </div>
      <div className='artwork-pill__actions'>{props.children}</div>
    </div>
  );
};
